<div class="heading">
    <p>Revoke Prompt</p>
</div>
<form #revokeForm="ngForm" (ngSubmit)="revokePrompt(revokeForm)">
    <div class="instruction">
        <p class="mb-32" *ngIf="!data?.isArchivetoRevoke">Revoking the <span style="font-weight: 700; word-break: break-word;">"{{data?.prompt_name}}"</span> prompt will transition it from a published state back to the creator in a revoked state, making it unavailable to the end user.</p>
        <p class="mb-32" *ngIf="data?.isArchivetoRevoke">Revoking the <span style="font-weight: 700; word-break: break-word;">"{{data?.prompt_name}}"</span> prompt will transition it from a archived state back to the creator in a revoked state, making it unavailable to the end user.</p>

        <div>
            <label style="font-size: 14px; color: #5E5E72; margin-bottom: 4px; display: inline-block; font-weight: 700;">Reason for Revoke<span style="color: red;">*</span></label>
            <textarea placeholder="Enter a reason here" style="width: 320px; height: 109px; font-family: 'Lato', sans-serif; border: 2px solid #E1E1EA; border-radius: 4px; padding: 10px; font-size: 16px;" [(ngModel)]="revokeReason" required #revokeField="ngModel" [ngModelOptions]="{standalone: true}"></textarea>
            <div *ngIf="formSubmitted && revokeField.invalid" style="color: red;">
                Revoke reason is required.
            </div>
        </div>


    </div>
    <div class="btn-container">
        <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" class="w-50 mr-12"
            (click)="cancelPrompt()"></app-button>
        <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Revoke'" class="w-50"
            (click)="revokePrompt(revokeForm)"></app-button>
    </div>
</form>